module.exports = __webpack_public_path__ + "static/media/person7.73766540.png";